import React from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { RowSectionType } from "../hook/useRowMenuToggle";

type Props = {
  rowId: string;
  canShowPix: boolean;
  canDelete: boolean;
  onSelect: (rowId: string, type: RowSectionType) => void;
  onDelete: (rowId: string) => void;
};

const RowDetailMenu: React.FC<Props> = ({
  rowId,
  canShowPix,
  canDelete = false,
  onSelect,
  onDelete,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const choose = (type: RowSectionType) => () => {
    handleClose();
    if (type === "pix" && !canShowPix) return;
    onSelect(rowId, type);
  };

  const handleDelete = () => {
    handleClose();
    if (canDelete) onDelete(rowId);
  };

  return (
    <>
      <Tooltip title="Mais opções">
        <IconButton onClick={handleOpen} aria-label="menu de opções">
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem onClick={choose("orders")}>
          <ListItemText primary="Acompanhe seus pedidos" />
        </MenuItem>

        <MenuItem onClick={choose("pix")} disabled={!canShowPix}>
          <ListItemText
            primary="Área Pix"
            secondary={
              !canShowPix
                ? "Disponível apenas para pagamento à vista"
                : undefined
            }
          />
        </MenuItem>

        <MenuItem onClick={handleDelete} disabled={!canDelete}>
          <ListItemText
            primary="Excluir pedido"
            secondary={!canDelete ? "Indisponível para este pedido" : undefined}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default RowDetailMenu;
